/* eslint-disable consistent-return */
import { check } from 'meteor/check';

import * as styleOps from '../style-operations';
import Styles from '../Styles';

import checkAuthentication from '../../../modules/server/check-authentication';

import handleMethodException from '../../../modules/handle-method-exception';

const editStyleSchema = Styles.schema.omit('owner', 'createdAt', 'updatedAt', 'deleted');
editStyleSchema.extend({ _id: String });

/**
 * Fetchs one style from the database.
 *
 * @param {string} styleId - The style id.
 * @returns {object} Return the style from the database.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const fetchOne = styleId => {
  try {
    // FIXME: Seguro que hay alguna forma mejor pero esto es lo que se me ocurre
    // checkAuthentication();
    return Styles.findOne(
      { _id: { $eq: styleId }, deleted: { $eq: 'no' } },
      {
        fields: {
          // TODO: poner los campos que no quiero compartir.
          owner: 0
        }
      }
    );
  } catch (error) {
    handleMethodException(error);
  }
};

/**
 * Inserts the style in the database.
 *
 * @async
 * @param {object} styleObject - The style object.
 * @param {string} userId - The user id.
 * @returns {string} Return the id of the new style.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const insert = async (styleObject, userId) => {
  check(userId, String);
  try {
    checkAuthentication();
    Styles.schema.validate(styleObject, {
      check,
      keys: ['name', 'styleType', 'geojsonStyle', 'rasterStyle']
    });
    return Styles.insert({ owner: userId, ...styleObject });
  } catch (exception) {
    handleMethodException(exception);
  }
};

/**
 * Updates the style in the database.
 *
 * @param {object} styleObject - The style object.
 * @returns {string} Return the id of the updated style.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const update = styleObject => {
  try {
    checkAuthentication();
    editStyleSchema.validate(styleObject);
    const styleId = styleOps.getId(styleObject);
    Styles.update(styleId, { $set: styleObject });
    return styleId;
    // Return _id so we can redirect to style after update.
  } catch (exception) {
    handleMethodException(exception);
  }
};

/**
 * Copies the style in the database.
 *
 * @param {string} styleId - The style id.
 * @param {string} userId - The user id that wants the style.
 * @returns {string} Return the id of the new style copied.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const copy = (styleId, userId) => {
  check(styleId, String);
  check(userId, String);
  try {
    checkAuthentication();
    const copyStyleData = Styles.findOne({ _id: styleId });
    delete copyStyleData.owner;
    delete copyStyleData._id;
    delete copyStyleData.createdAt;
    delete copyStyleData.updatedAt;
    delete copyStyleData.deleted;
    copyStyleData.name += ' - copy';
    const copyStyleId = Styles.insert({ owner: userId, ...copyStyleData });
    return copyStyleId;
  } catch (exception) {
    handleMethodException(exception);
  }
};

/**
 * Soft deletes the style in the database.
 *
 * @param {string} styleId - The style id.
 * @returns {string} Return the id of the style.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const softDelete = styleId => {
  check(styleId, String);
  try {
    checkAuthentication();
    return Styles.update(styleId, { $set: { deleted: new Date().toISOString() } });
  } catch (exception) {
    handleMethodException(exception);
  }
};

/**
 * Restores the style in the database.
 *
 * @param {string} styleId - The style id.
 * @returns {string} Return the id of the style.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const restore = styleId => {
  check(styleId, String);
  try {
    checkAuthentication();
    return Styles.update(styleId, { $set: { deleted: 'no' } });
  } catch (exception) {
    handleMethodException(exception);
  }
};

/**
 * Deletes the style from database.
 *
 * @param {string} styleId - The style id.
 * @returns {string} Return the id of the deleted style.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const hardDelete = styleId => {
  check(styleId, String);
  try {
    checkAuthentication();
    return Styles.remove(styleId);
  } catch (exception) {
    handleMethodException(exception);
  }
};
